export enum AppLanguage {
   ARABIC = 'ar',
   ENGLISH = 'en'
}
